import type { AmbiguousTradePair } from "./types";

export const AMBIGUOUS_TRADE_PAIRS: AmbiguousTradePair[] = [
  {
    selectedTrade: "General contractor",
    selectedTradeDefinition:
      "an individual who is responsible for scheduling and overseeing the day-to-day activities of a construction project. They rarely do physical work themselves and typically hire subcontractors for specialized work, such as plumbers or electricians.",
    alternativeTrade: "Handyperson",
    alternativeTradeDefinition:
      'A business, contractor, or individual skilled in a wide range of repair or maintenance activities typically performed in the residential space. These are sometimes described as "side jobs", "odd jobs", or "fix-up tasks". This trade is not intended for businesses focused on building construction or remodeling operations.',
    alternativeTradeHint:
      'If you primarily do minor repair or maintenance services including "odd jobs" or "fix-up" tasks',
  },
];

export const findAmbiguousTradePair = (
  tradeValue: string,
): AmbiguousTradePair | undefined =>
  AMBIGUOUS_TRADE_PAIRS.find(pair => pair.selectedTrade === tradeValue);
